import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { MerchantMissionPage } from './merchant-mission';

@NgModule({
  declarations: [
    MerchantMissionPage,
  ],
  imports: [
    IonicPageModule.forChild(MerchantMissionPage),
    TranslateModule.forChild()
  ],
})
export class MerchantMissionPageModule {}



// WEBPACK FOOTER //
// ./src/pages/merchant-mission/merchant-mission.module.ts